import { render, staticRenderFns } from "./CoursewareTabsContainer.vue?vue&type=template&id=a26e21c2&"
import script from "./CoursewareTabsContainer.vue?vue&type=script&lang=js&"
export * from "./CoursewareTabsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports